export { QRScanner } from "./QRScanner";
